import { Controller } from "@hotwired/stimulus"
import DataTable from "datatables.net-bs5"
import polish from "../lib/datatables_pl"

// Sortable/searchable table (DataTables), without paging. Put the controller
// on an element around the table: DataTables moves the table into its own
// wrapper, which Stimulus would otherwise see as a disconnect.
//   data-datatable-order-value='[[0, "desc"]]'
//   data-datatable-hidden-columns-value='[6]'
export default class extends Controller {
  static targets = ["table"]
  static values = {
    order: { type: Array, default: [] },
    hiddenColumns: { type: Array, default: [] },
    searching: { type: Boolean, default: true }
  }

  connect() {
    const columnDefs = this.hiddenColumnsValue.length
      ? [{ targets: this.hiddenColumnsValue, visible: false, orderable: false }]
      : []

    this.table = new DataTable(this.tableTarget, {
      retrieve: true,
      paging: false,
      responsive: false,
      searching: this.searchingValue,
      order: this.orderValue,
      columnDefs,
      language: polish
    })
  }

  disconnect() {
    this.table?.destroy()
  }
}
